import { Capacitor } from '@capacitor/core';

// iOS WebView runs on a real HTTPS origin (configured via Capacitor server.iosScheme/hostname)
// so Azure Functions CORS and Entra SPA origin validation accept it. This is a local WebView
// origin and does not require public DNS.
export const CAPACITOR_WEB_ORIGIN = 'https://app.renewmyday.com';
export const NATIVE_AUTH_REDIRECT_URI = 'renewmyday://auth/callback';
export const NATIVE_AUTH_CALLBACK_PATH = '/auth/callback';

// Public, video-provider-allowlisted HTTPS origin where the web app (including the
// /video-embed.html wrapper) is published. Native WebView shells load embeds through this
// origin so providers like Vimeo see an allowlisted referrer instead of capacitor://localhost.
export const VIDEO_EMBED_ORIGIN =
  process.env.REACT_APP_VIDEO_EMBED_ORIGIN || 'https://kim-preview.renewmyday.com';

export const isNativeApp = (): boolean => Capacitor.isNativePlatform();

export const isIOSNativeApp = (): boolean => Capacitor.getPlatform() === 'ios';

export const getNativePlatform = (): string => Capacitor.getPlatform();